import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { HomeLayouts } from '../../components/layouts/HomeLayouts';
import DesktopQuotes from './components/DesktopQuotes';
import moment from 'moment';
import styles from './myOrders.module.scss';
import { quoteByRestaurant } from '../../api/quotes';
import { useSelector } from 'react-redux';
import Loading from '../../components/Loading';
import SearchBar from '../../components/SearchBar';
import { Box, TablePagination } from '@mui/material';

const options = [15, 10, 5];

export const Quotes = () => {
  const { restaurant, user, token } = useSelector((state) => state.auth);
  const [quotes, setquotes] = useState(null);
  const navigate = useNavigate();
  const [page, setpage] = useState(0);
  const [selectedTab, setSelectedTab] = useState(0);
  const [loading, setLoading] = useState(false);
  const [params, setParams] = useState({
    page: 1,
    limit: 10,
    status: 'Solicitada,Completada',
    query: '',
  });

  useEffect(() => {
    loadQuotes(true);
  }, [restaurant]);

  useEffect(() => {
    loadQuotes(false);
  }, [params]);

  const loadQuotes = async (showLoading) => {
    if (!restaurant) return;
    if (showLoading) setLoading(true);
    const resp = await quoteByRestaurant(token, user.id, restaurant, params.status, params.limit, params.page);
    if (resp.ok) {
      setquotes(resp.data);
    } else {
      setquotes({ quotes: [], totalCount: 0 });
    }
    if (showLoading) setLoading(false);
  };

  const handleChangePage = (event, newPage) => {
    setpage(newPage);
    setParams({ ...params, page: newPage + 1 });
  };

  const handleChangeRowsPerPage = (event) => {
    setpage(0);
    setParams({ ...params, page: 1, limit: parseInt(event.target.value, 10) });
  };

  if (loading) return <HomeLayouts><Loading /></HomeLayouts>;

  return (
    <HomeLayouts>
      <div style={{ background: '#ffffff', minHeight: '100%' }}>
        <div className={styles.content}>
          <div className={styles.header}>
            <h1 className={styles.title}>Mis Cotizaciones</h1>
          </div>

          <div className={styles['search-and-filter']}>
            <SearchBar
              query={params.query}
              setQuery={(val) => setParams({ ...params, query: val, page: 1 })}
              placeholder="Buscar cotizaciones..."
              name="query"
            />
          </div>

          <div className={styles['status-tab']}>
            <div
              className={`${styles.status} ${selectedTab === 0 ? styles.active : ''}`}
              onClick={() => {
                setpage(0);
                setSelectedTab(0);
                setParams({ ...params, page: 1, status: 'Solicitada,Completada' });
              }}
            >
              Solicitadas
            </div>
            <div
              className={`${styles.status} ${selectedTab === 1 ? styles.active : ''}`}
              onClick={() => {
                setpage(0);
                setSelectedTab(1);
                setParams({ ...params, page: 1, status: 'Aceptada,Rechazada' });
              }}
            >
              Anteriores
            </div>
          </div>

          {/* Mobile card list */}
          <div className={styles['orders-container']}>
            {quotes && quotes.quotes.map((order, i) => (
              <div
                key={`${i}_${order.id}`}
                className={`${styles['order-wrapper']} ${styles[order.status]}`}
                onClick={() => navigate(`/cotizaciones/detalle_cotizacion/${order.code}`, { state: { order } })}
              >
                <div className={styles.order}>
                  <div className={styles['order-information']}>
                    <p className={styles.supplier}>{order.nameSupplier}</p>
                    <p className={styles.date}>
                      {moment(order.createdAt).format('DD MMM YYYY')}
                    </p>
                    <label className={`${styles.label} ${styles[order.status]}`}>
                      {order.status}
                    </label>
                  </div>
                  <p className={styles['id-order']}>{order.code}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Desktop table */}
          {quotes && (
            <DesktopQuotes orders={quotes.quotes} />
          )}
        </div>

        <Box sx={{ mr: { xs: 0, md: 35 } }}>
          <TablePagination
            component="div"
            labelRowsPerPage="Filas por página"
            rowsPerPageOptions={options}
            count={quotes ? quotes.totalCount : 0}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={parseInt(params.limit)}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Box>
      </div>
    </HomeLayouts>
  );
};
